import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { ArtikelRabattstaffel, ArtikelRabattstaffelApi } from './rabatt-staffel.component';

@Injectable({ providedIn: 'root' })
export class RabattStaffelService {
    constructor(
        private http: HttpClient,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    getRabattStaffeln(materialId: string): Observable<ArtikelRabattstaffelApi> {
        const params = new HttpParams().set('artikel_id', materialId);
        return this.http.get<ArtikelRabattstaffelApi>(this.apiBaseUrl + 'artikel_rabattstaffel/read.php', {
            params: params,
        });
    }

    remove(rs: ArtikelRabattstaffel): Observable<void> {
        return this.http.post<void>(this.apiBaseUrl + 'artikel_rabattstaffel/delete.php', rs);
    }

    save(rs: ArtikelRabattstaffel): Observable<ArtikelRabattstaffel> {
        return this.http.post<ArtikelRabattstaffel>(this.apiBaseUrl + 'artikel_rabattstaffel/update.php', rs);
    }
}
